import Dashboard from "views/Dashboard/Dashboard.jsx";
import NewForm from "views/Forms/NewForm";
import SmileCenters from "views/SmileCenters/SmileCenters";
import CloseSession from "views/Account/CloseSession";
import PriceList from "views/Info/PriceList";
import MoonsFlow from "views/Info/MoonsFlow";
import Configuration from "views/Account/Configuration/Configuration";

var dashboardRoutes = [
  {
    path: "/dashboard",
    layout: "/admin",
    name: "Pacientes",
    icon: "fa fa-users",
    component: Dashboard
  },
  {
    collapse: true,
    path: "/info",
    name: "¿Como funciona?",
    state: "openForms",
    icon: "fa fa-sitemap",
    views: [
    {
      path: "/info/moonsflow",
      name: "Proceso moons",
      mini: "Pm",
      component: MoonsFlow,
    },
    {
      path: "/info/price",
      name: "Precios",
      mini: "P",
      component: PriceList,
    },
    {
      path: "/smilecenters",
      name: "Centros de escaneo",
      mini: "SC",
      component: SmileCenters
    },
    ]
  },
  {
    path: "/account",
    layout: "/admin",
    name: "Configuración",
    icon: "fa fa-cog",
    component: Configuration
  },
  {
    path: "/closesession",
    layout: "/admin",
    name: "Cerrar sesión",
    icon: "fa fa-sign-out",
    component: CloseSession
  },
  {
    collapse: true,
    hide:true,
    path: "/forms",
    name: "Ortodoncistas",
    state: "openForms",
    icon: "pe-7s-note2",
    views: [
      {
        path: "/forms/newform",
        name: "Editar",
        mini: "E",
        component: NewForm,
        hide:true
      },
      
    ]
  },
  { redirect: true, path: "/", pathTo: "/dashboard", name: "dashboard" }
];
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx